module.exports = __webpack_public_path__ + "static/media/131.8e5f1c80.wav";